import { useMemo } from "react";
import useEventDefinition from "hooks/useEventDefinition";
import useEventById from "hooks/useEventById";
const useAlertAndEventDefinitionData = (alertId, definitionId) => {
  const { data: eventData, isLoading: isLoadingEvent } = useEventById(alertId);
  const { data, isLoading: isLoadingEventDefinition } = useEventDefinition(
    definitionId != null ? definitionId : eventData == null ? void 0 : eventData.event_definition_id
  );
  const eventDefinition = data == null ? void 0 : data.eventDefinition;
  const aggregations = data == null ? void 0 : data.aggregations;
  const isLoading = alertId && isLoadingEvent || definitionId && isLoadingEventDefinition;
  return useMemo(
    () => ({
      alertId,
      definitionId: eventDefinition == null ? void 0 : eventDefinition.id,
      definitionTitle: eventDefinition == null ? void 0 : eventDefinition.title,
      eventData,
      eventDefinition,
      aggregations,
      isLoading
    }),
    [alertId, eventDefinition, eventData, aggregations, isLoading]
  );
};
export default useAlertAndEventDefinitionData;
